@if (contentlet()) {
<div
  class="default-video-class box-video-banner-container position-relative"
  [ngClass]="bannerVideoWidth(contentlet())"
>
  @if (buildVideoSrc() | async | dotCmsCodecEncode; as videoSrc) {
  <video
    loop
    width="100%"
    height="100%"
    playsInline
    [src]="videoSrc"
    [autoplay]="contentlet()?.disableAutoplay?.length > 0 ? false : true"
    muted
    class="dotcms-video"
  ></video>
  }
  <div class="video-overlay"></div>
  <div class="video-banner-caption">
    <custom-dot-cms-banner-link [contentlet]="contentlet()" />
  </div>
</div>
}
